var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center "},[_c('img',{staticStyle:{"max-width":"621px"},attrs:{"src":require('@/assets/images/JourneySoFar.png'),"alt":"Journey So Far","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }